export default {
  development: 'http://localhost:3800',
  production: 'https://beta.qmkey.com/backend',
};
